import { ApplicationConfig } from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { withInMemoryScrolling } from '@angular/router';
import { provideCabinetApp } from '@core-session';
import { provideLandingIndexingPolicy } from '@feature-landing';
import { PlatformType } from '@data-access';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    // The landing header switches pages through the router: a new page starts at the top, Back
    // returns to where the reader was, and a `#fragment` (the `/shippers#services` deep link the
    // trademark filing cites) scrolls to that element.
    provideCabinetApp(PlatformType.WebLogin, routes, [
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
    ]),
    // The landing pages are prerendered (app.routes.server.ts): hydration adopts that HTML instead
    // of re-rendering it, so the hero video and the layout don't restart once the bundle boots.
    provideClientHydration(withEventReplay()),
    provideLandingIndexingPolicy(),
  ],
};
